"use client";

import React from "react";
import { Loader, CircleCheck, CircleAlert } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
function InquiryForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <Alert className="bg-green-50 border-green-200 text-green-800 dark:bg-green-950/50 dark:border-green-900 dark:text-green-400">
        <CircleCheck className="size-5 text-green-600 dark:text-green-500" />
        <AlertTitle className="font-default font-semibold">Uspješno poslano!</AlertTitle>
        <AlertDescription className="mt-2 flex flex-col gap-4">
          <p>{successMessage}</p>
          <Button onClick={resetForm} variant="outline" className="w-fit">
            Pošalji novi upit
          </Button>
        </AlertDescription>
      </Alert>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="name" rules={{
        required: "Ime i prezime je obavezno",
        minLength: {
          value: 2,
          message: "Minimalno 2 znaka"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Ime i prezime</FormLabel>
              <FormControl>
                <Input placeholder="Ivan Horvat" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "E-mail adresa je obavezna",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Neispravna e-mail adresa"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>E-mail adresa</FormLabel>
              <FormControl>
                <Input type="email" placeholder="ivan@primjer.hr" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="company" render={({
        field
      }) => <FormItem>
              <FormLabel>Tvrtka (opcionalno)</FormLabel>
              <FormControl>
                <Input placeholder="Naziv vaše tvrtke" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="phone" render={({
        field
      }) => <FormItem>
              <FormLabel>Broj telefona (opcionalno)</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+385 91 234 5678" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="message" rules={{
      required: "Poruka je obavezna",
      minLength: {
        value: 10,
        message: "Poruka mora sadržavati barem 10 znakova"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Vaša poruka</FormLabel>
            <FormControl>
              <Textarea placeholder="Opišite nam svoj projekt ili postavite pitanje..." className="min-h-[120px] resize-y" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <Alert variant="destructive">
          <CircleAlert className="size-4" />
          <AlertTitle className="font-default font-semibold">Greška</AlertTitle>
          <AlertDescription>{submitError}</AlertDescription>
        </Alert>}

      <Button type="submit" disabled={isSubmitting} className="w-full md:w-auto md:min-w-[200px]">
        {isSubmitting ? <>
            <Loader className="mr-2 size-4 animate-spin" />
            Slanje...
          </> : "Pošalji upit"}
      </Button>
    </Form>;
}
export default function SuccessPathFormHome() {
  return <section id="success-path-form" className="bg-background py-16 md:py-24 lg:py-32">
      <div id="success-path-container" className="container mx-auto px-4 md:px-6">
        <div className="mx-auto max-w-3xl">
          <Card className="border-border/50 shadow-lg dark:shadow-none">
            <CardHeader className="text-center pb-8">
              <CardTitle className="font-default text-3xl md:text-4xl font-bold text-foreground mb-3">
                Započnite svoj projekt
              </CardTitle>
              <CardDescription className="text-base md:text-lg text-muted-foreground max-w-xl mx-auto">
                Ispunite obrazac ispod s detaljima vašeg upita, a naš tim stručnjaka javit će vam se u najkraćem mogućem roku.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <FormProvider formId="success-path-form-home" sectionName="SuccessPathFormHome" defaultValues={{
              name: "",
              email: "",
              company: "",
              phone: "",
              message: ""
            }} submitText="Pošalji upit" successMessage="Hvala vam na upitu! Naš tim će vas uskoro kontaktirati." errorMessage="Došlo je do pogreške prilikom slanja obrasca. Molimo pokušajte ponovno.">
                <InquiryForm />
              </FormProvider>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}